<template>
  <div>
    <el-row class="sign-up-form">
      <el-col :span="24">
        <div>
          <div class="sign-up-form-input">
            <el-form
              :label-position="lablePosition"
              label-width="13rem"
              ref="ruleForm"
              :model="form"
            >
              <el-form-item label="作品名称：" prop="worksName">
                <el-input placeholder="请输入项目名称" v-model="form.worksName" readonly></el-input>
              </el-form-item>
              <!--               <el-form-item label="作品类别：" prop="worksType">-->
              <!--                <el-radio-->
              <!--                  v-model="form.worksType"-->
              <!--                  :label="item.id"-->
              <!--                  :key="index"-->
              <!--                  v-for="(item,index) in worksTypes"-->
              <!--                  :disabled="true"-->
              <!--                >{{item.title}}</el-radio>-->
              <!--              </el-form-item>-->
              <el-form-item label="作品简介：" prop="brief">
                <el-input
                  v-model="form.brief"
                  type="textarea"
                  :autosize="{minRows: 4, maxRows: 4}"
                  readonly
                ></el-input>
              </el-form-item>

              <el-form-item label="作品附件:" prop="logo">
                <!--                <fileComponentList-->
                <!--                  :businessCodeArray="businessCodeArray"-->
                <!--                  :remark="remark"-->
                <!--                  :completeArray="completeArray"-->
                <!--                ></fileComponentList>-->
                <div class="fileupload">
                  <el-row :gutter="10">
                    <el-col :span="20">
                      <el-card class="box-card" style="margin-top: 10px">
                        <div slot="header" class="clearfix">
                          <i class="el-icon-folder-checked"></i>
                          <span>作品相关文件</span>
                        </div>

                        <div
                          class="text item"
                          v-for="(item, index) in fileList"
                          :key="index"
                        >
                          <el-row>
                            <el-col :span="16">
                              <i class="el-icon-folder-checked"></i>
                              <span>{{item.fileDict}} : <a :href="item.path" s>{{ item.name }}</a></span>
                            </el-col>
                          </el-row>
                        </div>
                      </el-card>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
              <el-form-item label="作品评分：" prop="finalGrade">
                <el-input
                  v-model="form.finalGrade"
                  type="text"
                  placeholder
                  :autosize="{minRows: 4, maxRows: 4}"
                  readonly
                ></el-input>
              </el-form-item>
              <el-form-item label="作品评价：" prop="comment">
                <el-input
                  v-model="form.comment"
                  type="textarea"
                  placeholder
                  :autosize="{minRows: 4, maxRows: 4}"
                  readonly
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="info" @click="closeForm">返回</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ChildLogo from '@/components/ChildLogo.vue'
import fileComponentList from '@/components/fileComponentList'
import {getWorkFile} from '@/api/work/workdata'
import {getTitles, getSite} from '@/api/work/index'
import {deleteFiles} from '@/api/system/index'
import {getFileList} from '@/api/system/index'

export default {
  components: {
    ChildLogo,
    fileComponentList,
  },
  data () {
    return {
      ruleForm: {
        remark: ''
      },
      //作品id
      workId: undefined,
      //专家id
      expertId: undefined,
      //类型
      worksTypes: [],
      fileList: [],
      fileIdList: [],
      businessCodeArray: [],
      completeArray: [],
      form: {
        id: null,
        worksName: '',
        worksType: '',
        worksLeader: '',
        userName: '',
        duty: '',
        mobile: '',
        cooperator: '',
        responsibility: '',
        participantId: null,
        siteId: this.siteId,
        final_grade: '',
        remark: '',
        comment: '',
      },
      remark: undefined,
      lablePosition: 'right',
    }
  },
  created () {
    this.workId = this.$route.query.id
    this.expertId = this.$route.query.expertId
    this.getSiteInfo()
  },
  beforeMount () {
    // 添加判断方法
    let mobile = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    if (mobile) {
      this.lablePosition = 'top'
    }
  },
  mounted () {
    /* window.addEventListener("beforeunload", (e) => this.beforeunloadFn(e));
    window.addEventListener("unload", (e) => this.exit(e)); */

    this.getFileSList(this.workId)
  },
  methods: {
    getSiteInfo () {
      var url = this.baseURL + '/actuator/works/getInfoDetail'
      this.axios
        .get(url, {params: {id: this.workId, expertNumber: this.expertId}})
        .then((response) => {
          if (response.data.code === 200) {
            let obj = new Object()
            let workDatas = JSON.parse(response.data.data[0].worksName)
            obj.id = response.data.data[0].id
            obj.worksName = workDatas.workName
            obj.brief = workDatas.brief
            obj.finalGrade = response.data.data[0].grade
            obj.comment = response.data.data[0].comment
            this.form = obj
            this.workId = response.data.data[0].id
          }
        })
    },
    getContParticipant () {
    },
    closeForm () {
      this.$router.replace('/workRating')
    },
    /**
     * 获取作品列表
     */
    getFileSList (id) {
      getWorkFile(this.siteURL, id).then((response) => {

        let files = []
        response.data.forEach(function (item, index) {
          let file = {}
          file.fileDict = item.fileDict
          file.name = item.fileName
          file.path = item.path
          files.push(file)
        })

        console.log(response.data)

        this.fileList = files

      })
      // if(this.remark === "") {
      //   return
      // }
      // if (this.businessCodeArray) {
      //   getFileList(url, this.remark).then((res) => {
      //         this.completeArray = res.data.completeArray
      //        for (let i = 0; i < res.data.completeArray.length; i++) {
      //         this.fileList.push({
      //           name: res.data.completeArray[i].fileName,
      //           url: res.data.completeArray[i].path,
      //         });
      //       }
      //   });
      // }
    },
  },
}
</script>

<style scoped>
/* 通知公告基础模块 */
.sign-up {
  min-height: 80px;
}

/* 通知公告竖线样式 */
.sign-up-line {
  float: left;
  width: 5px;
  height: 50px;
  background-image: linear-gradient(#133c73, #37babd);
  margin-top: 20px;
}

.sign-up-text {
  margin-left: 10px;
  float: left;
  height: 40px;
  margin-top: 20px;
}

.sign-up-text-cn {
  font-size: 24px;
}

.sign-up-text-en {
  font-size: 15px;
  color: #666666;
}

/* 表单基础样式 */
.sign-up-form {
  margin-top: 10px;
  height: 100%;
  padding: 0.5rem;
  background-color: #f5f5f5;
}

.sign-up-form-input {
  width: 100%;
  background-color: #f5f5f5;
}

/* elementui   表单控件长度修改 */
.el-select {
  width: 100%;
}

.el-input {
  width: 100%;
}

.bottom {
  margin-top: 0;
  text-align: center;
  color: #409eff;
  line-height: 19px;
  font-size: 14px;
  cursor: pointer;
}

.buttonDiv {
  margin: 50px;
  padding: 0 25%;
}

.el-upload__tip {
  line-height: 20px;
}
</style>
<style>
.el-form-item__label {
  font-size: 16px !important;
}

.el-upload-list__item-name {
  cursor: pointer;
}

.el-upload-list__item-name:hover {
  color: #409eff;
}

.el-radio__input.is-checked + .el-radio__label {
  color: #39c1c2;
}

.el-radio__input.is-checked .el-radio__inner {
  border-color: #39c1c2;
  background: #39c1c2;
}
</style>



// WEBPACK FOOTER //
// src/views/WorkDetail.vue